const s = {
  name: "_2Angle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40.1" style="enable-background:new 0 0 40 40.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,35.2V0H0v40.1l20-20l20,20V0h-2v35.2L21.4,18.6l7.9-7.9l-1.4-1.4L20,17.2l-7.9-7.9l-1.4,1.4l7.9,7.9
			L2,35.2z"/>
		<path class="st0" d="M20,0c-2.8,0-5,2.2-5,5s2.2,5,5,5c2.8,0,5-2.2,5-5S22.8,0,20,0z M17,5c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3
			s-1.3,3-3,3C18.3,8,17,6.7,17,5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as _2Angle
};
